document.querySelectorAll('[data-native-intake]').forEach(function (root) {
      const find = id => root.querySelector('[id="'+id+'"]');
      'use strict';
      const entities = {'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'",'&#x27;':"'"};
      const config = JSON.parse(root.querySelector('[data-intake-config]').textContent, (key,value) => typeof value === 'string' ? value.replace(/&(?:amp|lt|gt|quot|#39|#x27);/g, match => entities[match]) : value);
      const copy = config.copy;
      const form = find('intake');
      const send = find('send');
      const busy = find('busy');
      const errorBox = find('error');
      const fieldHolder = find('fields');
      const filesHolder = find('file-inputs');
      const addFile = find('add-file');
      let pending = false;
      let watchdog;
      
      
      const node = function (tag, className, text) { const element = document.createElement(tag); if (className) element.className = className; if (typeof text === 'string') element.textContent = text; return element; };
      form.elements.mode.value = config.mode;
      form.elements.ticket.value = '';
      let ticketRequest;
      let ticketReadyAt = 0;
      let attemptedSend = false;
      function getTicket() {
        if (!ticketRequest) ticketRequest = (async () => {
          const url = new URL(config.endpoint);
          url.searchParams.set('transport','web'); url.searchParams.set('mode',config.mode);
          const response = await fetch(url, {credentials:'omit',redirect:'follow',cache:'no-store'});
          if(!response.ok) throw new Error('connection');
          const result = await response.json();
          if(!result.ok || typeof result.ticket !== 'string') throw new Error('connection');
          form.elements.ticket.value = result.ticket; ticketReadyAt = Date.now();
          return result.ticket;
        })().catch(error => { ticketRequest = null; throw error; });
        return ticketRequest;
      }
      getTicket().catch(() => {});
      find('intro').textContent = config.mode === 'quote' ? copy.quote_intro : copy.meeting_intro;
      send.textContent = config.mode === 'quote' ? copy.quote_send : copy.meeting_send;
      find('submit-note').textContent = config.mode === 'quote' ? copy.quote_note : copy.meeting_note;

      function makeField(field) {
        if (field.type === 'checkbox') {
          const label = node('label');
          const input = node('input'); input.type = 'checkbox'; input.id = field.name; input.name = field.name; input.value = 'Yes';
          label.append(input, node('span', '', field.label));
          return label;
        }
        const wrapper = node('div','field');
        const label = node('label','',field.label + (field.required ? ' *' : '')); label.htmlFor = field.name;
        const input = node(field.type === 'textarea' ? 'textarea' : field.type === 'select' ? 'select' : 'input');
        input.id = field.name; input.name = field.name; input.required = !!field.required;
        if (input.tagName === 'INPUT') input.type = field.type;
        if (field.type === 'select') {
          const empty = node('option','',copy.select); empty.value = ''; input.append(empty);
          field.options.forEach(function (option) { const choice = node('option','',option); choice.value = option; input.append(choice); });
        } else input.maxLength = field.max;
        if (field.type === 'textarea') input.rows = field.name === 'goals' ? 5 : 3;
        if (field.autocomplete) input.autocomplete = field.autocomplete;
        if (field.placeholder) input.placeholder = field.placeholder;
        if (field.type === 'email' || field.type === 'url') { input.autocapitalize = 'none'; input.spellcheck = false; }
        wrapper.append(label,input);
        if (field.help) { const help = node('p','help',field.help); help.id = field.name+'-help'; input.setAttribute('aria-describedby',help.id); wrapper.append(help); }
        return wrapper;
      }

      function populate(container, fields) {
        const checkboxFields = fields.filter(function (field) { return field.type === 'checkbox'; });
        if (checkboxFields.length) {
          const choiceSet = node('fieldset','choices'); choiceSet.append(node('legend','',copy.support));
          const checks = node('div','check-grid'); checkboxFields.forEach(function (field) { checks.append(makeField(field)); }); choiceSet.append(checks); container.append(choiceSet);
        }
        const normal = fields.filter(function (field) { return field.type !== 'checkbox'; });
        normal.forEach(function (field,index) {
          if (index === 0 && normal.length > 1 && field.name === 'name' && normal[1].name === 'email') {
            const row = node('div','row'); row.append(makeField(field),makeField(normal[1])); container.append(row);
          } else if (!(index === 1 && normal[0].name === 'name' && field.name === 'email')) container.append(makeField(field));
        });
      }
      if (config.mode === 'quote') {
        const details = node('div','details');
        config.groups.forEach(function (group,index) {
          const section = node('fieldset','form-section');
          const legend = node('legend',index ? 'sr-only' : '',group.title); section.append(legend);
          section.append(node('p','section-intro',group.intro));
          populate(section,config.schema.filter(function (field) { return field.group === group.key; }));
          if (!index) fieldHolder.append(section);
          else {
            const detail = node('details','detail'); const summary = node('summary');
            const toggle = node('span','toggle'); toggle.setAttribute('aria-hidden','true');
            summary.append(node('span','',group.title),node('span','optional',copy.optional),toggle); detail.append(summary,section); details.append(detail);
          }
        });
        fieldHolder.append(details);
      } else {
        const fields = node('fieldset','form-section'); fields.append(node('legend','',copy.meeting_fields)); populate(fields,config.schema); fieldHolder.append(fields);
      }

      function fileRows() { return Array.from(filesHolder.children); }
      function updateFiles() {
        let count = 0; let total = 0;
        fileRows().forEach(function (row) { const file = row.querySelector('input').files[0]; if (file) { count++; total += file.size; } });
        addFile.hidden = !fileRows().some(function (row) { return row.hidden; });
        find('file-total').textContent = count ? count + (count === 1 ? copy.one_file : copy.many_files) + (total/1048576).toFixed(2) + copy.total : '';
        requestResize();
      }
      for (let index = 1; index <= config.maxFiles; index++) {
        const row = node('div','file-row'); row.hidden = index > 1;
        const wrapper = node('div','field'); const label = node('label','',copy.attachment+index); label.htmlFor = 'file_'+index;
        const input = node('input'); input.id = input.name = 'file_'+index; input.type = 'file'; input.accept = '.pdf,.docx,.jpg,.jpeg,.png,.webp,.gif,.txt'; input.disabled = index > 1; input.setAttribute('aria-describedby','file-help');
        input.addEventListener('change',function () { errorBox.hidden = true; updateFiles(); });
        const remove = node('button','remove',copy.remove); remove.type = 'button'; remove.setAttribute('aria-label',copy.remove_attachment+index);
        remove.addEventListener('click',function () { input.value = ''; if (index > 1) { row.hidden = true; input.disabled = true; addFile.focus(); } else input.focus(); updateFiles(); });
        wrapper.append(label,input); row.append(wrapper,remove); filesHolder.append(row);
      }
      addFile.addEventListener('click',function () { const row = fileRows().find(function (candidate) { return candidate.hidden; }); if (!row) return; row.hidden = false; const input = row.querySelector('input'); input.disabled = false; input.focus(); updateFiles(); });

      function showError(message, field) {
        find('error-message').textContent = message;
        errorBox.hidden = false;
        if (field) {
          const input = form.elements.namedItem(field);
          if (input) { const detail = input.closest('details'); if (detail) detail.open = true; input.setAttribute('aria-invalid','true'); input.setAttribute('aria-errormessage','error-message'); }
        }
        errorBox.focus(); requestResize();
      }
      function setPending(value) {
        pending = value; send.disabled = value;
        form.setAttribute('aria-busy',String(value));
        busy.textContent = value ? copy.sending : '';
      }
      form.addEventListener('invalid',function (event) { const detail = event.target.closest('details'); if (detail) detail.open = true; requestResize(); },true);
      form.addEventListener('input',function (event) { event.target.removeAttribute('aria-invalid'); event.target.removeAttribute('aria-errormessage'); });
      form.addEventListener('submit',async function (event) {
        event.preventDefault(); if (pending) return;
        errorBox.hidden = true;
        if (!form.reportValidity()) return;
        const chosen = fileRows().map(function (row) { return row.querySelector('input'); }).filter(function (input) { return input.files.length; });
        let total = 0;
        for (const input of chosen) {
          const file = input.files[0];
          if (!/\.(pdf|docx|jpe?g|png|webp|gif|txt)$/i.test(file.name)) { showError(copy.file_type,input.name); return; }
          if (!file.size || file.size > config.maxFileBytes) { showError(copy.file_size,input.name); return; }
          total += file.size;
        }
        if (total > config.maxTotalBytes) { showError(copy.total_size); return; }
        setPending(true);
        watchdog = window.setTimeout(function () { busy.textContent = copy.slow; },45000);
        try {
          await getTicket();
          if(Date.now() - ticketReadyAt < 2100) await new Promise(resolve => window.setTimeout(resolve,2100 - (Date.now() - ticketReadyAt)));
          const fields = {};
          new FormData(form).forEach((value,key) => { if(typeof value === 'string') fields[key] = value; });
          const files = await Promise.all(chosen.map(input => new Promise((resolve,reject) => {
            const file = input.files[0]; const reader = new FileReader();
            reader.onload = () => resolve({name:file.name,type:file.type,data:String(reader.result).split(',')[1]});
            reader.onerror = () => reject(new Error('file'));
            reader.readAsDataURL(file);
          })));
          attemptedSend = true;
          const response = await fetch(config.endpoint,{method:'POST',headers:{'Content-Type':'text/plain;charset=UTF-8'},credentials:'omit',redirect:'follow',body:JSON.stringify({transport:'web',fields,files})});
          if(!response.ok) throw new Error('connection');
          const result = await response.json();
          if(!result || !result.ok) {
            if(result && result.code === 'expired') { ticketRequest = null; attemptedSend = false; }
            showError(result && result.message ? result.message : copy.unconfirmed,result && result.field); return;
          }
          form.hidden = true; errorBox.hidden = true;
          find('success-title').textContent = result.duplicate ? copy.duplicate_title : config.mode === 'quote' ? copy.quote_success : copy.meeting_success;
          find('success-message').textContent = result.duplicate ? copy.duplicate_body : copy.success_body;
          find('success-reference').textContent = copy.reference + result.reference;
          const success = find('success'); success.hidden = false; success.focus();
          if (config.mode === 'quote' && !result.duplicate) document.dispatchEvent(new CustomEvent('vivid:quote-accepted'));
        } catch (error) {
          showError(attemptedSend ? copy.interrupted : copy.connection_error);
        } finally { window.clearTimeout(watchdog); setPending(false); }
      });

      function requestResize() {}
      form.hidden = false;
    });
